<template>
  <div class="print-receive-page">
    <div class="receive-header">
      <div class="receive-header-row">
        <div class="receive-header-item">
          <b class="receipt-title">{{ $t('accountancy.documents.print.receive.receiveReceipt') }}</b>
          <div><b>{{ $t('accountancy.documents.print.receive.transactionId') }}</b> {{ receive.transactionId || '' }}</div>
          <div><b>{{ $t('accountancy.documents.print.receive.paymentConfirm') }}</b> {{ receive.paymentConfirmId || '' }}</div>
        </div>

        <div class="receive-header-item">
<!--          <img class="shop-logo" src="https://tennisshop.ir/wp-content/uploads/2021/04/LOGO-TENNIS-SHOP.png"-->
<!--               alt="tennis_shop">-->
          <img class="shop-logo" :src="getClubLogo" alt="tennis_shop">
        </div>

        <div class="receive-header-item">
          <div></div>
          <div class="flex"><b>{{ $t('accountancy.documents.print.receive.date') }}</b> <span class="date">{{ receive.date }}</span></div>
          <div><b>{{ $t('accountancy.documents.print.receive.docNumber') }}</b> {{ receive.serial || '' }}</div>
        </div>

      </div>
    </div>

    <div class="receive-body">
      <div class="receive-details">
        <template v-for="(item, key) in receive.description">
          <div v-if="item.hasOwnProperty('value')"
               :class="item.class ? `detail-item ${item.class}` : 'detail-item'"
               :style="item.style ? item.style : ''"
               :key="key">
            {{ item.value }}
          </div>
          <div v-else :key="key" class="detail-item">
            {{ item }}
          </div>
        </template>
      </div>
    </div>
    <div class="receive-signatures">
      <div class="signature-item">
        {{ $t('accountancy.documents.print.receive.nameAndSignature') }}
        <br>
        {{ $t('accountancy.documents.print.receive.receiver') }}
      </div>
      <div class="signature-item">
        {{ $t('accountancy.documents.print.receive.nameAndSignature') }}
        <br>
        {{ $t('accountancy.documents.print.receive.payer') }}
      </div>
      <div class="signature-item">
        {{ $t('accountancy.documents.print.receive.nameAndSignature') }}
        <br>
        {{ $t('accountancy.documents.print.receive.confirmer') }}
      </div>
    </div>

    <div class="btn-controls">
      <button @click="printPage" class="btn">
        {{ $t('accountancy.documents.print.receive.print') }}
      </button>
      <button class="btn">
        {{ $t('accountancy.documents.print.receive.back') }}
      </button>
    </div>
  </div>
</template>

<script>
import Num2persian from 'num2persian'
import {addComma} from '../../../../../assets/js/functions'
import {getReceive} from "../../../../../http/requests/documents";

export default {
  name: 'PrintReceive',

  data () {
    return {
      sourceTypesMapper: {
        'User': '',
        'Bank': this.$t('accountancy.documents.print.cost.bank'),
        'Cash': this.$t('accountancy.documents.print.cost.cashBox'),
        'Storeroom': this.$t('accountancy.documents.print.cost.storeroom'),
        'PaymentGateway': this.$t('accountancy.documents.print.cost.paymentGateway')
      },
      receive: {
        date: '',
        serial: '',
        description: []
      }
    }
  },

  computed: {
    getClubLogo () {
      return this.$store.state.setting.clubInfo.club_logo
    }
  },

  created () {
    this.getReceive()
  },

  methods: {
    getReceive () {
      getReceive(this.$route.params.id).then(response => {
        const data = response.data.data

        // console.log(data)
        this.receive.date = data.date
        this.receive.serial = data.document_id
        this.receive.transactionId = data.transaction_id || ''
        this.receive.paymentConfirmId = data.confirmation_id || ''
        this.receive.description.push({
          value: this.$t('accountancy.documents.print.receive.description.confirm'),
          style: 'min-width: 100%;'
        })
        this.receive.description.push(this.$t('accountancy.documents.print.receive.description.price'))
        this.receive.description.push({
          value: `${addComma(Math.abs(data.price))  } ${this.$t('currency')}`,
          class: 'grow'
        })
        this.receive.description.push(this.$t('accountancy.documents.print.receive.description.toText'))
        this.receive.description.push({
          value: `${Num2persian(Math.abs(data.price))  } ${this.$t('currency')}`,
          class: 'grow'
        })
        this.receive.description.push(this.$t('accountancy.documents.print.receive.description.payee'))
        this.receive.description.push({
          value: `${data.payer.name || ''} ${data.payer.family || ''}`,
          class: 'grow'
        })
        this.receive.description.push(this.$t('accountancy.documents.print.receive.description.inDate'))
        this.receive.description.push({
          value: data.date || '',
          class: 'grow rtl'
        })
        if (data.description) {
          this.receive.description.push(this.$t('accountancy.documents.print.receive.description.description'))
          this.receive.description.push({
            value: data.description,
            class: 'grow'
          })
        }
        this.receive.description.push(this.$t('accountancy.documents.print.receive.description.payer'))
        this.receive.description.push({
          value: `${data.payee.name || data.payee.title}`,
          class: 'grow'
        })
        this.receive.description.push(this.$t('accountancy.documents.print.receive.description.payed'))
      })
    },

    printPage () {
      window.print()
    }
  }
}
</script>

<style lang="scss">
  $divider: #cdcdcd;

  div#app {
    background-color: #fff;
  }

  .print-receive-page {
    width: 21cm;
    margin: auto;
    background: #fff;
    padding: .5cm;
    font-weight: 400;
    font-size: 13px;
    line-height: 30px;

    .receive-header {
      border: 1px solid #cecece;
      padding: 10px;

      .receive-header-row {
        display: flex;

        .receive-header-item {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          flex-grow: 1;
          width: 25%;
          font-weight: 500;
          text-align: center;

          .date {
            direction: rtl;
            margin-left: 5px;
          }

          .receipt-title {
            font-size: 13pt;
          }

          &:nth-child(odd) {
            align-items: start;
          }

          &:nth-child(2) {
            width: 50%;
          }
        }

        div, b {
          flex: 1;
          line-height: 50px;
        }

        img {
          object-fit: scale-down;
          height: 100px;
        }
      }
    }

    .receive-body {
      padding: 10px 20px;
      border: 1px solid $divider;
      border-top: 0;
      min-height: 220px;
      line-height: 45px;


      .receive-details {
        display: flex;
        flex-wrap: wrap;

        .detail-item {
          min-width: 15%;

          &.grow {
            text-align: center;
            font-weight: bold;
            min-width: 35%;
          }
        }
      }
    }

    .receive-signatures {
      display: flex;
      justify-content: space-between;
      border: 1px solid $divider;
      border-top: 0;

      .signature-item {
        width: 33.33%;
        min-height: 120px;
        padding: 10px 20px;
        border-right: 1px solid $divider;

        &:last-child {
          border-right: 0;
        }
      }
    }

    .btn-controls {
      margin-top: 50px;
      display: flex;
      justify-content: center;

      .btn {
        cursor: pointer;
        font-weight: 500;
        font-size: 13px;
        line-height: 40px;
        background: #cecece50;
        border: 1px solid #cecece;
        border-radius: .5rem;
        min-width: 120px;
        transition: all .3s ease;

        &:first-child {
          margin-right: 10px;
        }

        &:hover {
          background: #cecece90;
        }
      }
    }

    @media print {
      * {
        font-size: 12pt !important;
      }

      .header-item {
        font-size: 13pt !important;
      }

      .signature-item {
        font-size: 12pt !important;
      }

      .btn-controls {
        display: none !important;
      }
    }
  }

  @page {
    margin: 5mm;
  }

</style>
